var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"border":"top","colored-border":"","type":"info","color":"orange","elevation":"2"}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }